import './PendingChangesPanel.scss';
import { ReactNode } from 'react';
import { Header } from '../StickyTable';
import { displayValue, renderValue, RowType } from './pending-changes-utils';

interface PendingDeletedRowProps<R> {
  columns: Header[];
  oldRow: R;
  pendingRowHeaderRender?: (row: R) => ReactNode;
}

export const PendingDeletedRow = <R extends RowType>({
  columns,
  oldRow,
  pendingRowHeaderRender
}: PendingDeletedRowProps<R>) => (
  <div className='pending-changes-row-container pending-deleted-row-container'>
    {pendingRowHeaderRender && (
      <div className='pending-changes-row-title'>{pendingRowHeaderRender(oldRow)}</div>
    )}
    {columns.map(col => {
      const { label, field, renderer } = col;
      const oldVal = displayValue(oldRow[field ?? '']);
      return (
        <div key={label}>
          <div className='pending-changes-row'>
            <b className='pending-changes-row-label'>{label}:</b>
            <div>{renderer ? renderValue(renderer(oldRow)) : oldVal}</div>
          </div>
        </div>
      );
    })}
  </div>
);
